import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useAppStore } from '@/store/app-store'
import type { APIGameType } from '@/types'
import { getUACFromCookies30d } from '@/utils/cookie-parser'

const ORGANIC_AUTOPLAY_GAMES = [
    'ball-eating-simulator',
    'fragen',
    'shop-cashier-simulator-3d',
    'flag-coloring-puzzle',
    'mega-parkour-obby-escape-run',
    'army-evolution-merge--tactics',
    'bubble-word-jam',
    'little-princess-dress-up',
    'tailor-stylist-fashion-diary',
    'wordeck-associations',
    'master-scavenger',
    'railway-bridge',
    'chickz-stack',
    'change-the-score--football-2026',
    'draw-path-to-home',
    'piece-of-cake-merge--bake',
    '67-game',
    'rooftop-run',
    'geometry-arrow-2',
    'geometry-vibes',
    'my-town-home-family-playhouse',
    'deadly-descent',
    'yarn-fever-unravel-puzzle',
    'geometry-arrow',
    'zap',
    'obby-minigames',
    'dummy-world-cup-playgama',
    'asmr-girl-livestream-mukbang',
    'hexellent',
    'stickman-kombat-2d',
]

export const useGameAutoplayStore = defineStore('gameAutoplay', () => {
    const appStore = useAppStore()
    const isFirstAutoplay = ref(true)

    function shouldAutoplay(game: APIGameType | undefined, isPlatformAvailable: boolean): boolean {
        if (import.meta.env.SSR || !isFirstAutoplay.value || !game) {
            return false
        }

        const uac = getUACFromCookies30d(document.cookie)

        return (
            ORGANIC_AUTOPLAY_GAMES.includes(game.hru) &&
            isPlatformAvailable &&
            !game.is_hidden &&
            appStore.platform === 'desktop' &&
            !appStore.isAppEnv &&
            uac.medium === 'referral' &&
            uac.source?.toLowerCase().includes('google') === true
        )
    }

    function markAutoplayStarted() {
        isFirstAutoplay.value = false
    }

    return {
        isFirstAutoplay,
        shouldAutoplay,
        markAutoplayStarted,
    }
})
